export default __webpack_public_path__ + "4221597f386d368eb4259f0faa2783ce.png";